const Loader = () => {
  return (
    <div className="ct_loader_main">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
